'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _comments = require('./comments.component');

var _comments2 = _interopRequireDefault(_comments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commentsModule = _angular2.default.module('comments', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.comments', {
    url: '/comments',
    component: 'comments'
  });
}).component('comments', _comments2.default).name;

exports.default = commentsModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/comments/comments.js